import React, { useState } from "react";
import { Container, Tab } from "semantic-ui-react";
import { useHistory } from "react-router-dom";

import TabPaneCT1 from "./tabs/TabPaneCT1";
import TabPaneCT6 from "./tabs/TabPaneCT6";
import TabPaneCT from "./tabs/TabPaneCT";

const styles = {
	containerStyle: {
		paddingTop: 30,
		marginTop: 40,
	},
	tabStyle: {
		overflow: "hidden auto",
		maxHeight: "85vh",
		display: "flex",
		flexDirection: "column",
	},
};

const CT3_GROUP = process.env.REACT_APP_CT3 || "CT3";
const CT7_GROUP = process.env.REACT_APP_CT7 || "CT7";

const NurseMobility = () => {
	const history = useHistory();
	const [openFolderManager, setOpenFolderManager] = useState(false);

	const panes = [
		{ menuItem: "CT1", render: () => <TabPaneCT1 setOpenFolderManager={setOpenFolderManager} /> },
		{ menuItem: "CT3", render: () => <TabPaneCT setOpenFolderManager={setOpenFolderManager} ctGroup={CT3_GROUP} /> },
		{ menuItem: "CT6", render: () => <TabPaneCT6 setOpenFolderManager={setOpenFolderManager} /> },
		{ menuItem: "CT7", render: () => <TabPaneCT setOpenFolderManager={setOpenFolderManager} ctGroup={CT7_GROUP} /> },
	];
	if (openFolderManager) {
		console.log("NurseMobility openFolderManager true, redirect to /home/foldermanager");
		history.push("/home/foldermanager");
	}

	return (
		<Container style={styles.containerStyle}>
			<Tab style={styles.tabStyle} menu={{ secondary: true, pointing: true }} panes={panes} renderActiveOnly={true} />
		</Container>
	);
};

export default NurseMobility;
